import { useEffect } from 'react';

function useOutsideOfReact({ element, hook, value }) {
  useEffect(() => {
    // #panel-hotels-label is outside of React
    const hotelsLabel = element;
    const handleClick = () => hook(value);

    hotelsLabel.addEventListener('click', handleClick);

    return () => {
      hotelsLabel.removeEventListener('click', handleClick);
    };
  });
}

export default useOutsideOfReact;
